import { defineStore } from "pinia";

export const useFrontPageDataStore = defineStore("frontPageData", {
  state: () => ({
    serviceType: null,
    faqs: [],
    profession: null,
    _serviceTypePromise: null,
    _faqsPromise: null,
  }),

  getters: {
    serviceTypeLoaded: (state) => state.serviceType !== null,
    faqsLoaded: (state) => state.faqs.length > 0,
  },

  actions: {
    async loadServiceType($query) {
      if (this.serviceTypeLoaded) return this.serviceType;
      if (this._serviceTypePromise) return await this._serviceTypePromise;

      this._serviceTypePromise = this._fetchServiceType($query);
      const result = await this._serviceTypePromise;
      this._serviceTypePromise = null;
      return result;
    },

    async _fetchServiceType($query) {
      try {
        const GET_SERVICE_TYPE_BY_TYPE_QUERY = await import(
          "@/components/_refactored/indexPage/getServiceTypeByType.graphql"
        );
        const { serviceTypes } = await $query(
          GET_SERVICE_TYPE_BY_TYPE_QUERY.default ||
            GET_SERVICE_TYPE_BY_TYPE_QUERY,
          { type: "price_offer" }
        );
        this.serviceType = serviceTypes?.[0] || null;
        return this.serviceType;
      } catch (error) {
        console.error("Error loading service type:", error);
        return null;
      }
    },

    async loadFaqs($query) {
      if (this.faqsLoaded) return this.faqs;
      if (this._faqsPromise) return await this._faqsPromise;

      this._faqsPromise = this._fetchFaqs($query);
      const result = await this._faqsPromise;
      this._faqsPromise = null;
      return result;
    },

    async _fetchFaqs($query) {
      try {
        const FAQS_QUERY = await import(
          "@/components/_refactored/indexPage/getFaqs.graphql"
        );
        const result = await $query(
          FAQS_QUERY.default || FAQS_QUERY,
          { type: "price_offer_professional" }
        );
        this.faqs = result.faqs || [];
        return this.faqs;
      } catch (error) {
        console.error("Error loading FAQs:", error);
        return [];
      }
    },

    async loadProfession($query, professionSeoName) {
      if (!professionSeoName) return null;

      try {
        const GET_PROFESSION_BY_SEO_NAME = await import(
          "~/graphql/profession.graphql"
        );
        const result = await $query(
          GET_PROFESSION_BY_SEO_NAME.default || GET_PROFESSION_BY_SEO_NAME,
          { professionSeoName },
          { showErrorPage: false, showErrorToast: false }
        );
        this.profession = result?.profession || null;
        return this.profession;
      } catch (error) {
        console.error("Error loading profession:", error);
        return null;
      }
    },
  },
});
